import React, { useState } from "react";
import { ICompletedBios } from "../GlobalComponents/HealthProfiles/UserBiomarkers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StartFav from "src/assets/images/website-images/start-fav.png";
import StartUnFav from "src/assets/images/website-images/start-unfav.png";
import {
  faChevronDown,
  faChevronUp,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { returnColor } from "src/helpers/helperFunctions";
import { Link } from "react-router-dom";
import SingleBioMarkerHistory from "../GlobalComponents/HealthProfiles/SingleBioMarkerHistory";
import { useResponsiveText } from "src/hooks/useResponsiveText";

interface IProps {
  item: ICompletedBios;
  userRole: "customer" | "admin";
  uid: string;
  dob: string;
  gender: string;
  isMyProfile: boolean;
  onSuccess: () => void;
  favApiCall?: (id: string) => void;
  onClose?: () => void;
  index?: number;
  isFavId?: string;
  isCustomer?: boolean;
}

const CompletedBioMarkerComponents: React.FC<IProps> = ({
  item,
  userRole = "customer",
  dob = "",
  gender = "",
  uid = "",
  isMyProfile = false,
  onSuccess = () => {},
  favApiCall = () => {},
  onClose = () => {},
  index = 0,
  isFavId = "",
  isCustomer = true,
}) => {
  const [selectedId, setSelectedId] = useState<string>("");
  
  // Get the display text for responsive sizing
  const displayText = (item?.barcategories === "twoBarDNDAsc" ||
    item?.barcategories === "twoBarDNDDesc") &&
  item?.value === "1"
    ? "Detected"
    : (item?.barcategories === "twoBarDNDAsc" ||
        item?.barcategories === "twoBarDNDDesc") &&
      item?.value === "0"
    ? "Not Detected"
    : (item?.barcategories === "twoBarPNAsc" ||
        item?.barcategories === "twoBarPNDesc") &&
      item?.value === "1"
    ? "Positive"
    : (item?.barcategories === "twoBarPNAsc" ||
        item?.barcategories === "twoBarPNDesc") &&
      item?.value === "0"
    ? "Negative"
    : item?.value + (item?.isShown ? " " + item?.measurement : "");

  const responsiveFontSize = useResponsiveText({ 
    text: displayText, 
    maxLength: 25
  });

  const navigateToDetail = (bioId: string): string => {
    if (userRole === "customer") {
      return `/bio-details/${uid}/${bioId}/view`;
    } else if (userRole === "admin") {
      return `/biomarker-result/${uid}/${bioId}/view`;
    } else {
      return "";
      // Future role-based navigation can be handled here
    }
  };

  return (
    <div>
      <div className="biomarker-new-ui biomarker-grid-completed">
        <div className="flex h-full justify-center">
          {userRole === "customer" ? (
            <button
              disabled={!isMyProfile}
              onClick={() => favApiCall(item?._id)}
              id={`${isFavId || ""}biomarker-fav-btn-${item?.name}`}
            >
              <img
                src={item?.isFavourite ? StartFav : StartUnFav}
                alt="start"
                className="w-[13px] h-[13px] xl:w-[15px] xl:h-[15px]"
              />
            </button>
          ) : (
            <div className="h-full border-[3px] border-[#46B710]"></div>
          )}
        </div>
        <div>
          <Link
            to={navigateToDetail(item?._id)}
            onClick={onClose}
            id={`${isFavId || ""}biomarker-link-${item?.name}`}
            className="font-size-18px text-white font-Poppins-Regular"
          >
            <span className="truncate w-full block">{item?.name || ""}</span>
          </Link>
        </div>
        <div className="flex justify-center">
          <span
            style={{ background: returnColor(item?.biomarkerColour) }}
            className={`new-biomarker-btn w-[98%] 2xl:py-1.5 py-1 mx-auto text-center font-Poppins-Regular text-white
              break-words hyphens-auto leading-tight
              min-h-[2rem] flex items-center justify-center px-1 ${responsiveFontSize}`}
          >
            <span className="truncate max-w-full">
              {displayText}
            </span>
          </span>
        </div>
        <div className="flex justify-center">
          <p className="font-size-15px text-white font-Poppins-Regular">
            {moment(item?.date).format("DD MMM YYYY")}
          </p>
        </div>
        <div className="flex justify-center">
          <FontAwesomeIcon
            onClick={() => setSelectedId(selectedId ? "" : item?._id)}
            className="cursor-pointer text-white"
            size="xs"
            icon={selectedId === item?._id ? faChevronUp : faChevronDown}
            id={`${isFavId || ""}biomarker-history-show-hide-btn-${item?.name}`}
          />
        </div>
      </div>
      {selectedId === item?._id && (
        <div className={`new-health-vitals-dropdown`}>
          <SingleBioMarkerHistory
            uid={uid}
            _date={dob}
            _gender={gender}
            bioId={item?._id}
            onSuccess={() => {
              onSuccess();
              setSelectedId("");
            }}
            isCustomer={isCustomer}
            index={index + 3000}
            customId={`${item?.name}`}
            isFavId={isFavId}
          />
        </div>
      )}
    </div>
  );
};

export default CompletedBioMarkerComponents;
